var _g, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFillHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 983,
    height: 1024,
    viewBox: "0 0 983 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M567.181 823.882c0 8.901-4.448 13.353-13.349 13.353h-124.621c-8.901 0-13.353-4.452-13.353-13.353v-275.939c0-8.901 4.452-13.353 13.353-13.353h124.621c8.901 0 13.349 4.452 13.349 13.353v275.939z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M754.115 837.202c22.254 0 35.602-17.805 35.602-35.607v-373.854c0-13.353-8.901-31.157-17.801-40.058l-249.238-195.829c-17.801-13.352-44.507-13.352-62.308 0l-249.237 195.829c-13.352 8.901-17.803 22.253-17.803 40.058v369.402c0 22.254 17.802 35.607 35.605 35.607h111.267v-338.252c0-22.254 17.803-35.602 35.605-35.602h226.985c22.254 0 35.602 17.801 35.602 35.602v338.252h115.72v4.452z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFillHome);
export default __webpack_public_path__ + "static/media/icon-fill-home.c41f4d51e92dbdbbd6bc323c2f44c78b.svg";
export { ForwardRef as ReactComponent };